<template>
  <input v-model="value1">
  <input v-model="value2">
</template>

<script>
export default {
  name: "myInput",
  data: () =>
  {
    return {
      value: {
        x: '',
        y: ''
      },
      value1:'',
      value2:'',
    }
  },
  watch: {
    value1()
    {
      console.log('emitting')
      this.$emit('input', {x:this.value1,y:this.value2});
    },
    value2()
    {
      console.log('emitting')
      this.$emit('input', {x:this.value1,y:this.value2});
    }
  }
}
</script>

<style scoped>

</style>